var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco09(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6595 0.570312C10.6813 0.570312 0.160156 11.0923 0.160156 24.07C0.160156 37.0477 10.6813 47.5706 23.6595 47.5706C36.6377 47.5706 47.1602 37.0484 47.1602 24.07C47.1602 11.0916 36.6377 0.570312 23.6595 0.570312ZM32.8722 15.3254L26.9036 32.163C26.8532 32.3053 26.7285 32.4076 26.5798 32.4292C26.4283 32.4499 26.2815 32.3886 26.193 32.2675L23.1621 28.1261L18.1517 33.1362C18.0724 33.2155 17.9684 33.2553 17.8644 33.2553C17.7604 33.2553 17.6563 33.2155 17.5771 33.1362L14.543 30.1022C14.3842 29.9433 14.3842 29.6865 14.543 29.5277L19.5531 24.5168L15.4114 21.4864C15.29 21.3974 15.2274 21.2487 15.2493 21.0996C15.2712 20.9504 15.3737 20.8257 15.5155 20.7758L32.353 14.8072C32.5009 14.7547 32.6654 14.7917 32.776 14.9026C32.8873 15.0129 32.9247 15.1775 32.8722 15.3254Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco09);
export default __webpack_public_path__ + "static/media/ico-09.e2f3c5c7e4ec0a3e4a423eebe1e2110e.svg";
export { ForwardRef as ReactComponent };